const Input = {
  baseStyle: {
    field: {
      _placeholder: { color: 'lightGray.500' },
    },
  },
};

export default Input;
